import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Duplicate = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.62457 6.6243C7.07779 6.17109 7.69247 5.91647 8.33342 5.91647H27.0834C27.7244 5.91647 28.339 6.17109 28.7923 6.6243C29.2455 7.07751 29.5001 7.6922 29.5001 8.33314V10.4165C29.5001 11.383 30.2836 12.1665 31.2501 12.1665C32.2166 12.1665 33.0001 11.383 33.0001 10.4165V8.33314C33.0001 6.76394 32.3767 5.25901 31.2671 4.14942C30.1575 3.03983 28.6526 2.41647 27.0834 2.41647H8.33342C6.76422 2.41647 5.25929 3.03983 4.1497 4.14942C3.04011 5.25902 2.41675 6.76394 2.41675 8.33314V27.0831C2.41675 28.6523 3.04011 30.1573 4.1497 31.2669C5.25929 32.3764 6.76422 32.9998 8.33342 32.9998H10.4167C11.3832 32.9998 12.1667 32.2163 12.1667 31.2498C12.1667 30.2833 11.3832 29.4998 10.4167 29.4998H8.33342C7.69248 29.4998 7.07779 29.2452 6.62457 28.792C6.17136 28.3388 5.91675 27.7241 5.91675 27.0831V8.33314C5.91675 7.6922 6.17136 7.07751 6.62457 6.6243Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9167 17C19.649 17 17 19.649 17 22.9167V41.6667C17 44.9344 19.649 47.5833 22.9167 47.5833H41.6667C44.9343 47.5833 47.5833 44.9344 47.5833 41.6667V22.9167C47.5833 19.649 44.9343 17 41.6667 17H22.9167ZM20.5 22.9167C20.5 21.582 21.582 20.5 22.9167 20.5H41.6667C43.0013 20.5 44.0833 21.582 44.0833 22.9167V41.6667C44.0833 43.0014 43.0013 44.0833 41.6667 44.0833H22.9167C21.582 44.0833 20.5 43.0014 20.5 41.6667V22.9167Z"
        fill={color}
      />
    </svg>
  )
}
